import { getAuth } from "firebase/auth";
import { initializeApp } from "@firebase/app";

import { getMessaging } from "@firebase/messaging";
import { getAnalytics } from "firebase/analytics";

Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
        console.log("Messaging: Notification permission granted.");
    } else {
        console.log("Messaging: Unable to get permission to notify.");
    }
});

export const VAPID_KEY = "BA73NCohcJz2DxLsIG3dJsHf83OzblVelTyfHcN1CJDGM8vWU9DRF6o4Z-_qXttM1bCLf1BaSBApUvgVcAv3r8c";
export const firebaseConfig = {
    // apiKey: "AIzaSyCet3XWDiaFjnq1m0L5G1kpNu_1c2VZ9P0",
    // authDomain: "marshaslab.firebaseapp.com",
    // projectId: "marshaslab",
    // storageBucket: "marshaslab.appspot.com",
    // messagingSenderId: "133879154855",
    // appId: "1:133879154855:web:5f3b3ba25fab77ca2c7382",
    // measurementId: "G-4909YYTCNR"
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const messaging = getMessaging(app);
